// extracted by mini-css-extract-plugin
module.exports = {"curatorsListWrapper":"IDi+C","curatorsListTitle":"CZ8wR","curatorsList":"_0PMf2","curatorsItem":"NNFEY"};